import { ArrowRight } from 'lucide-react';
import type { ArticleBlock as ArticleBlockType } from '@/shared/types/blocks';
import { Button } from '@/shared/ui/button';

type ArticleBlockProps = Omit<ArticleBlockType, 'type' | 'id'>;

/**
 * ArticleBlock - 기사/아티클 카드
 *
 * 뉴스 기사나 블로그 포스트를 카드 형태로 표시합니다.
 */
export function ArticleBlock({ title, summary, tags, date, sourceUrl }: ArticleBlockProps) {
  return (
    <article className="flex flex-col gap-4">
      {/* 제목 */}
      <h3 className="text-xl font-bold text-foreground">{title}</h3>

      {/* 태그 + 날짜 */}
      <div className="flex items-center justify-between">
        {tags && tags.length > 0 && (
          <div className="flex gap-2 flex-wrap">
            {tags.map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-xs font-bold border border-border rounded text-foreground"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
        {date && <span className="text-xs text-muted-foreground">{date}</span>}
      </div>

      {/* 요약 */}
      <p className="text-base text-muted-foreground leading-relaxed">{summary}</p>

      {/* Read More 버튼 */}
      {sourceUrl ? (
        <Button variant="outline" className="w-fit justify-center gap-2" asChild>
          <a href={sourceUrl} target="_blank" rel="noopener noreferrer">
            Read More
            <ArrowRight className="w-4 h-4" />
          </a>
        </Button>
      ) : (
        <Button variant="outline" className="w-fit justify-center gap-2">
          Read More
          <ArrowRight className="w-4 h-4" />
        </Button>
      )}
    </article>
  );
}
